<div class="boxes-area boxes-style-two bg-f5f7fa" style="min-height: calc(100vh - 220px);">
  <div class="container">
    <div class="row pt-5 pb-5">
      <ng-container *ngFor="let item of dataSource; index as i">
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="block block-rounded block-fx-shadow bg-image">
            <div class="block-content justify-content-between pt-2 pb-2 text-white bg-black-50 text-center"
              [style]="getBackgroudImageTrangThaiHoatDong(item.tramDoInfo)">
              <div>
                <p class="font-size-h4 font-w600 mb-0 text-capitalize">
                  <a routerLink="/bieudo/{{item.tramDoInfo.id}}" routerLinkActive="router-link-active"
                    class="font-size-h4 font-w600 text-white">{{item.tramDoInfo.title}}</a>
                </p>
                <p class="text-white-75 mb-0">
                  {{item.tramDoInfo.address}}
                </p>
              </div>
            </div>
            <div class="block-content p-0 ">
              <div class="col-12 no-gutters text-left">
                <ng-container *ngFor="let itemDulieu of item.dmYeuToDoDtos">
                  <div class="row border-bottom py-1 px-1">
                    <div class="col-1 text-center">
                      <i class="{{itemDulieu.icon}}"></i>
                    </div>
                    <div class="col-7">
                      {{itemDulieu.title}} ({{itemDulieu.code}}):
                    </div>
                    <div class="col-2">
                      <ng-container *ngIf="itemDulieu.dataOk">
                        <ng-container *ngIf="itemDulieu.trangThaiHoatDongData == 2">
                          <b class="text-success">{{itemDulieu.giaTri}}</b>
                        </ng-container>
                        <ng-container *ngIf="itemDulieu.trangThaiHoatDongData != 2">
                          <b>{{itemDulieu.giaTri}}</b>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!itemDulieu.dataOk">
                        <b class="text-danger">{{itemDulieu.giaTri}}</b>
                      </ng-container>
                    </div>
                    <div class="col-2">
                      ({{itemDulieu.donViDo}})
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="item.maxCountDmYeuToDo > item.dmYeuToDoDtos.length">
                  <ng-container *ngFor="let n of getNumSequence(item)">
                    <div class="row border-bottom py-1 px-1">
                      <div class="col-1 text-center">
                        &nbsp;
                      </div>
                      <div class="col-7">
                        &nbsp;
                      </div>
                      <div class="col-2">
                        &nbsp;
                      </div>
                      <div class="col-2">
                        &nbsp;
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
            <div class="block-content block-content-full block-content-sm  font-size-sm text-center">
              <i class="text-muted">
                Thời gian: {{item.tramDoInfo.modified | date: 'HH'}} giờ {{item.tramDoInfo.modified | date: 'mm'}} phút
                {{item.tramDoInfo.modified | date:
                'dd/MM/yyyy'}}
              </i>
            </div>
            <div class="block-content block-content-full block-content-sm  font-size-h4 text-center">
              <span>
                <i class="fa-solid fa-circle fs18 pr5 {{getTrangThaiHoatDongStyle(item.tramDoInfo)}}"></i>
              </span> &nbsp;
              <strong>{{getTrangThaiHoatDong(item.tramDoInfo)}}</strong>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>